export const dashboardWarnings = {
  'c.hidalgo@mundoestudiante.com': 'no se crean alumnos de prueba',
  'j.aguirre@mundoestudiante.com': 'qué guapo eres hoy, Jorge'
}
